import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a15303b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { id: "riskCompliance" }
const _hoisted_5 = { class: "serve_wrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "serve_item_title" }
const _hoisted_8 = { class: "serve_item_content" }
const _hoisted_9 = { class: "serve_wrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "serve_item_title" }
const _hoisted_12 = { class: "serve_item_content" }
const _hoisted_13 = { id: "productLibrary" }
const _hoisted_14 = { class: "product_wrap" }
const _hoisted_15 = { class: "product_box" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "circle" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "product_title" }
const _hoisted_20 = { class: "product_content" }
const _hoisted_21 = { class: "product_right" }
const _hoisted_22 = { class: "product_right_shadow" }
const _hoisted_23 = { class: "product_right_content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_25 = { class: "product_right_text" }
const _hoisted_26 = { id: "newsAndFocus" }
const _hoisted_27 = { class: "news_wrap" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "news_item_content" }
const _hoisted_30 = { class: "news_item_title" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { id: "contactUs" }
const _hoisted_33 = { class: "contactUs_content" }
const _hoisted_34 = { class: "content_left" }
const _hoisted_35 = { class: "left_half_bg" }
const _hoisted_36 = { style: {"margin-bottom":"20px"} }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-24gl-building2" })
], -1))
const _hoisted_38 = { class: "room_title" }
const _hoisted_39 = {
  class: "contract_content",
  style: {"margin-left":"40px"}
}
const _hoisted_40 = { style: {"margin-bottom":"20px"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-24gl-building2" })
], -1))
const _hoisted_42 = { class: "room_title" }
const _hoisted_43 = {
  class: "contract_content",
  style: {"margin-left":"40px"}
}
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<li data-v-4a15303b><div class=\"content_icon\" data-v-4a15303b><i class=\"iconfont icon-youxiang\" data-v-4a15303b></i></div><p class=\"contract_content\" data-v-4a15303b>reghub@reghubchina.com</p></li><li data-v-4a15303b><div class=\"content_icon\" data-v-4a15303b><i class=\"iconfont icon-wangluo\" data-v-4a15303b></i></div><p class=\"contract_content\" data-v-4a15303b>www.reghubchina.com</p></li>", 2)
const _hoisted_46 = { class: "content_right" }
const _hoisted_47 = { class: "contactUs_bottom" }

import {computed, reactive, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper';
import { useI18n } from 'vue-i18n';
import 'swiper/css';
import 'swiper/css/navigation';
import ModuleTitle from '@/components/titleStyle/index.vue';
import type { FormInstance, FormRules } from 'element-plus';
import { getBannerList } from '@/api/banner'
import { getNewsTabsList, getNewsColumnList } from '@/api/new'
import { useRouter } from 'vue-router';
import { setTime } from '@/utils/fn'
import { sendEmail } from '@/api/home';
import { ElMessage } from 'element-plus';
interface ListItem {
  resourcesType?: Number | String;
  contentUrl?: String;
  url?: String;
}
interface ObjItem {
  list?: ListItem[]
}
interface Obj {
  data: ObjItem
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter();
const onSwiper = () => {
  // console.log();
};
const modules = [Navigation];
const onSlideChange = () => {
  // console.log('slide change');
};
let lunboList = reactive<Obj>({
  data: {
    list: []
  }
})
let showSwiper = computed(() => {
  // console.log(lunboList.data.list.length);
  
  return lunboList.data.list.length
})
const serveList = computed(() => {
  return reactive([
    { type: 'article', title: t('page.regulatoryComplianceServe'), content: t('page.regulatoryComplianceContent') },
    { type: 'image', src: require('@/assets/images/page_serve1.png') },
    { type: 'article', title: t('page.riskManagementServe'), content: t('page.regulatoryComplianceContent1') },
    { type: 'image', src: require('@/assets/images/page_serve2.png') },
    { type: 'article', title: t('page.strategyAndOperationServe'), content: t('page.regulatoryComplianceContent2') },
    { type: 'image', src: require('@/assets/images/page_serve3.png') },
  ])
})
const productList = computed(() => {
  return reactive([
    { title: t('page.complianceManagement'), content: t('page.productContent1'), image: require('@/assets/images/合规管理.png') },
    { title: t('page.riskmanagement'), content: t('page.productContent2'), image: require('@/assets/images/风险管理.png') },
    { title: t('page.newSomething'), content: t('page.productContent3'), image: require('@/assets/images/趋势.png') },
    { title: t('page.libraryAndSetting'), content: t('page.productContent4'), image: require('@/assets/images/工具箱-01.png') },
  ])
})
let newsList = reactive({
  list: [ { url: '', name: '', createTime: '', modifyTime: '', abstracts: null} ]
})
const ruleFormRef = ref<FormInstance>();
const ruleForm = reactive({
  name: '',
  phone: '',
  email: '',
  remarks: '',
});
const rules = reactive<FormRules>({
  name: [],
  phone: [],
  email: [
    { required: true, message: t('page.inputEmail'), trigger: 'blur' },
    { type: 'email', message: t('page.inputCorrectEmail'), trigger: ['blur', 'change'] }
  ],
})
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return 
  await formEl.validate((valid, fields) => {
    if (valid) {
      sendEmail(ruleForm).then((res: any) => {
        if (res.code === 0) {
          ElMessage.success('发送成功')
        } else {
          ElMessage.error('发送失败')
        }
      })
    } else {
      console.log('errpr submit', fields)
    }
  })
};
const getBanner = () => {
  getBannerList({ type: 1, chineseEnglishType: 1 }).then((res: any) => {
    if (res.code === 0 || res.code === 200) {
      if (res.data && res.data.length) {
        // console.log(res);
        
        lunboList.data.list = res.data;
      }
    }
  })
}
getBanner();
const returnProduct = (index: number) => {
  router.push({
    path: '/product',
    query: {
      monmentIndex: index
    }
  })
}
const returnServe = (index: number) => {
  if (index === 0 || index === 2 || index === 4) {
    router.push({
      path: '/serve',
      query: {
        monmentIndex: index === 0 ? 0 : (index === 2 ? 1 : 2)
      }
    })
  }
}
const getNews = (id: number | string) => {
  getNewsColumnList({ pageSize: 3, pageIndex: 1, chineseEnglishType: 1, }).then((res: any) => {
    // specialColumnTypeId: id,
    if (res.code === 0 || res.code === 200) {
      newsList.list = res.data.specialColumnList;
    }
  })
}
const getNewsTabs = () => {
  getNewsTabsList({ chineseEnglishType: 1, }).then((res: any) => {
    if (res.code === 0 || res.code === 200) {
      getNews(res.data[0].id)
    }
  })
}
getNewsTabs();
const returnNews = () => {
  router.push('/news')
}
const check = (item: any) => {
  router.push({
    path: '/news/detail',
    query: {
      ...item
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showSwiper))
      ? (_openBlock(), _createBlock(_unref(Swiper), {
          key: 0,
          modules: modules,
          class: "swiper-container",
          navigation: "",
          loop: "",
          onSwiper: onSwiper,
          onSlideChange: onSlideChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lunboList).data.list, (item, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                class: "swiper-slide",
                key: index
              }, {
                default: _withCtx(() => [
                  ((item.resourcesType === 0))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({backgroundImage: `url(${item.url})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' })
                      }, null, 4))
                    : _createCommentVNode("", true),
                  ((item.resourcesType === 1))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: item.contentUrl,
                        style: _normalizeStyle({diaplay: 'block',width: '100%',height: '100%',backgroundImage: `url(${item.url})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' })
                      }, null, 12, _hoisted_2))
                    : _createCommentVNode("", true),
                  ((item.resourcesType === 2))
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 2,
                        controls: "",
                        src: item.url
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ModuleTitle, {
        title: _unref(t)('navMenu.assessServe')
      }, null, 8, ["title"]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serveList), (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (index < 3)
              ? (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (returnServe(index))
                }, [
                  (item.type === 'article')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(item.title), 1),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(item.content), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (item.type === 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "serve_item_img",
                        style: _normalizeStyle({ backgroundImage: `url(${item.src})` })
                      }, null, 4))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serveList), (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (index >= 3)
              ? (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (returnServe(index))
                }, [
                  (item.type === 'article')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(item.title), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(item.content), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (item.type === 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "serve_item_img",
                        style: _normalizeStyle({ backgroundImage: `url(${item.src})` })
                      }, null, 4))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_10))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(ModuleTitle, {
          title: _unref(t)('page.productLibrary')
        }, null, 8, ["title"]),
        _createElementVNode("ul", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productList), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "product_box_item",
              onClick: ($event: any) => (returnProduct(index))
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: item.image
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("p", _hoisted_19, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_20, _toDisplayString(item.content), 1)
            ], 8, _hoisted_16))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('page.productContent')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(ModuleTitle, {
        title: _unref(t)('page.newsAndFocus'),
        titleMargin: '0 50px'
      }, null, 8, ["title"]),
      _createElementVNode("ul", _hoisted_27, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList).list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("img", {
              src: item.url,
              alt: ""
            }, null, 8, _hoisted_28),
            _createElementVNode("p", _hoisted_29, _toDisplayString(item.name), 1),
            _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(setTime)(item.createTime)), 1),
            _createElementVNode("div", {
              class: "news_check_btn",
              onClick: ($event: any) => (check(item))
            }, "查看", 8, _hoisted_31)
          ]))
        }), 128))
      ]),
      _createVNode(_component_el_button, {
        size: "large",
        type: "warning",
        class: "newsMoreBtn",
        plain: "",
        onClick: returnNews
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('page.checkMoreNews')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(ModuleTitle, {
        title: _unref(t)('navMenu.contactUs'),
        titleMargin: '0 50px'
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(t)('page.beijingRoom')), 1),
                _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(t)('page.beijingPlace')), 1)
              ]),
              _createElementVNode("li", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(t)('page.hongKongRoom')), 1),
                _createElementVNode("p", _hoisted_43, _toDisplayString(_unref(t)('page.hongKongPlace')), 1)
              ]),
              _hoisted_44
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: ruleForm,
            rules: rules,
            class: "demo-ruleForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.name) = $event)),
                    placeholder: _unref(t)('page.inputName')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "phone" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.phone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.phone) = $event)),
                    placeholder: _unref(t)('page.inputPhoneNumber')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "email" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.email) = $event)),
                    placeholder: _unref(t)('page.inputEmail')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.remarks,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.remarks) = $event)),
                    type: "textarea",
                    placeholder: _unref(t)('page.inputRemark')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value))),
                    style: {"width":"100%","height":"40px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('page.submit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('footer.introduce')), 1)
      ])
    ])
  ]))
}
}

})